import React, { createContext, useContext, useState, useRef, useCallback } from 'react';
import { useTranslation } from './I18nContext';
// ... rest of LoadingContext code ...// Manages a global loading state for API calls.
const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
    const [isLoading, setIsLoading] = useState(false);
    const loaderTimeoutRef = useRef(null);
    const LOADER_TIMEOUT_MS = 20000; // 10 seconds timeout for loader

    const startLoading = useCallback(() => {
        setIsLoading(true);
        if (loaderTimeoutRef.current) {
            clearTimeout(loaderTimeoutRef.current);
        }
        loaderTimeoutRef.current = setTimeout(() => {
            setIsLoading(false);
            console.warn("Loader timed out. Data fetch might still be in progress or failed silently.");
        }, LOADER_TIMEOUT_MS);
    }, []);

    const stopLoading = useCallback(() => {
        setIsLoading(false);
        if (loaderTimeoutRef.current) {
            clearTimeout(loaderTimeoutRef.current);
            loaderTimeoutRef.current = null;
        }
    }, []);

    return (
        <LoadingContext.Provider value={{ isLoading, startLoading, stopLoading }}>
            {children}
        </LoadingContext.Provider>
    );
};

export const useLoading = () => {
    return useContext(LoadingContext);
};
